/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ObserveRpcsAddObserveBody {
  /**
   * name
   * requirements:
   * must not be empty and must have at least a length of 2 characters
   * max 253 chars
   * no spaces
   */
  name?: string;
  namespace?: string;
  /** @format int64 */
  volumeSize?: string;
  storageClass?: string;
  minioUrl?: string;
  accessKey?: string;
  secretKey?: string;
  image?: string;
  imagePullPolicy?: MinioImagePullPolicy;
  imagePullSecrets?: MinioImagePullSecrets;
  imageRegistryConfig?: MinioImageRegistryConfig;
  resources?: MinioResourceRequirements;
  env?: MinioEnvVars;
  ingestConfig?: MinioIngestConfig;
  nodeSelector?: MinioNodeSelector;
  tolerations?: MinioToleration[];
  db?: MinioDBConfig;
  tenantReference?: string;
}

export interface ObserveRpcsUpdateObserveBody {
  fields?: MinioObserveUpdateFields;
}

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface MinioClaims {
  claim?: string[];
}

export interface MinioDBConfig {
  storageClass?: string;
  /** @format int64 */
  volumeSize?: string;
}

export type MinioEmpty = object;

export interface MinioEnvVar {
  name?: string;
  /** TODO: add valuefrom */
  value?: string;
}

export interface MinioEnvVars {
  vars?: MinioEnvVar[];
}

/** @default "Always" */
export enum MinioImagePullPolicy {
  Always = "Always",
  Never = "Never",
  IfNotPresent = "IfNotPresent",
}

export interface MinioImagePullSecrets {
  secrets?: string[];
}

export interface MinioImageRegistryConfig {
  registry?: string;
  username?: string;
  password?: string;
}

export interface MinioIngestConfig {
  url?: string;
  peers?: string;
  /** @format int32 */
  replicas?: number;
  enableBackup?: boolean;
  backupInterval?: string;
  minioHostURL?: string;
  minioRegion?: string;
  minioBucket?: string;
  minioBucketPrefix?: string;
}

export interface MinioLimits {
  /** @format int64 */
  memory?: string;
  /** @format int64 */
  cpu?: string;
}

export interface MinioNodeSelector {
  keyValueMap?: Record<string, string>;
}

export interface MinioObserve {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
  status?: MinioObserveStatus;
}

export interface MinioObserveDetails {
  resourceID?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  volumeSize?: string;
  storageClass?: string;
  minioUrl?: string;
  image?: string;
  imagePullPolicy?: MinioImagePullPolicy;
  imagePullSecrets?: MinioImagePullSecrets;
  resources?: MinioResourceRequirements;
  env?: MinioEnvVars;
  ingestConfig?: MinioIngestConfig;
  nodeSelector?: MinioNodeSelector;
  tolerations?: MinioToleration[];
  db?: MinioDBConfig;
  tenantReference?: string;
}

export interface MinioObserveServices {
  server?: MinioServiceDetails;
  db?: MinioServiceDetails;
  ingest?: MinioServiceDetails;
}

export interface MinioObserveStatus {
  currentState?: string;
  services?: MinioObserveServices;
}

export interface MinioObserveUpdateFields {
  /** @format int64 */
  volumeSize?: string;
  storageClass?: string;
  minioUrl?: string;
  accessKey?: string;
  secretKey?: string;
  image?: string;
  imagePullPolicy?: MinioImagePullPolicy;
  imagePullSecrets?: MinioImagePullSecrets;
  imageRegistryConfig?: MinioImageRegistryConfig;
  resources?: MinioResourceRequirements;
  env?: MinioEnvVars;
  ingestConfig?: MinioIngestConfig;
  nodeSelector?: MinioNodeSelector;
  tolerations?: MinioToleration[];
  db?: MinioDBConfig;
  tenantReference?: string;
}

export interface MinioRequests {
  /** @format int64 */
  memory?: string;
  /** @format int64 */
  cpu?: string;
}

export interface MinioResourceRequirements {
  requests?: MinioRequests;
  limits?: MinioLimits;
  claims?: MinioClaims;
}

export interface MinioServiceDetails {
  healthStatus?: string;
  /** @format int32 */
  podsRunning?: number;
  /** @format int32 */
  podsCrashing?: number;
}

/** @default "NoSchedule" */
export enum MinioTaintEffect {
  NoSchedule = "NoSchedule",
  PreferNoSchedule = "PreferNoSchedule",
  NoExecute = "NoExecute",
}

export interface MinioToleration {
  key?: string;
  operator?: MinioTolerationOperator;
  value?: string;
  effect?: MinioTaintEffect;
  /** @format int64 */
  seconds?: string;
}

/** @default "Equal" */
export enum MinioTolerationOperator {
  Equal = "Equal",
  Exists = "Exists",
}

export interface ProtobufAny {
  "@type"?: string;
  [key: string]: any;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title observe.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags ObserveRpcs
     * @name GetObserve
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/observes/{resourceID}
     */
    getObserve: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioObserveDetails, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/observes/${resourceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ObserveRpcs
     * @name DeleteObserve
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/observes/{resourceID}
     */
    deleteObserve: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/observes/${resourceId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ObserveRpcs
     * @name UpdateObserve
     * @request PUT:/api/v2/sites/{siteID}/namespaces/{namespace}/observes/{resourceID}
     */
    updateObserve: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: ObserveRpcsUpdateObserveBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioObserveDetails, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/observes/${resourceId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ObserveRpcs
     * @name AddObserve
     * @request POST:/api/v2/sites/{siteID}/observes
     */
    addObserve: (
      siteId: string,
      body: ObserveRpcsAddObserveBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioObserve, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/observes`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
